import { render, staticRenderFns } from "./OrdersPage.vue?vue&type=template&id=cc5225ba&scoped=true&"
import script from "./OrdersPage.vue?vue&type=script&lang=js&"
export * from "./OrdersPage.vue?vue&type=script&lang=js&"
import style0 from "./OrdersPage.vue?vue&type=style&index=0&id=cc5225ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5225ba",
  null
  
)

export default component.exports